import { useState } from 'react';

import { FormDataType, ValidationError } from '@types';
import { formatISODate } from '@utils/date';

interface UseGroupEndDateOptions {
  formData: FormDataType;
  onInputChange: (field: string, value: any) => void;
  hasCustomTermValidation?: boolean;
  error?: ValidationError;
  setError?: (value: ValidationError) => void;
}

const formatDate = (date: string | Date) =>
  formatISODate({
    date: new Date(date),
    separator: '-',
    format: 'yyyy-mm-dd'
  });

const useGroupEndDate = ({
  formData,
  onInputChange,
  hasCustomTermValidation = false,
  error,
  setError
}: UseGroupEndDateOptions) => {
  const [isEndDateModalOpen, setIsEndDateModalOpen] = useState(false);

  const endDateMinDate = () => {
    if (formData?.startDate) {
      if (new Date(formData?.startDate) < new Date()) return new Date();
      return new Date(formData?.startDate);
    }
    return new Date();
  };

  const endDateSelectedDate = () => {
    if (formData?.endDate) {
      return new Date(formData?.endDate);
    }
    if (formData?.startDate) {
      if (new Date(formData?.startDate) < new Date()) return new Date();
      return new Date(formData?.startDate);
    }
    return new Date();
  };

  const onEndDateChange = (endDate: any) => {
    const formattedEndDate = formatDate(endDate);
    onInputChange('endDate', formattedEndDate);
    setIsEndDateModalOpen(false);

    if (hasCustomTermValidation) {
      if (
        endDate &&
        formData.isCustomTerm &&
        formData.termsList &&
        new Date(new Date(endDate).setHours(0, 0, 0, 0)) <
          new Date(
            new Date(
              formData.termsList[formData.termsList.length - 1].termEndDate
            ).setHours(0, 0, 0, 0)
          )
      ) {
        setError?.({
          ...error,
          endDate: "Deactivation date must be after the final term's end date"
        });
      } else {
        setError?.({ ...error, endDate: '' });
      }
    }
  };

  const onClearEndDate = () => {
    onInputChange('endDate', '');
    if (hasCustomTermValidation) {
      setError?.({ ...error, endDate: '' });
    }
  };

  return {
    isEndDateModalOpen,
    setIsEndDateModalOpen,
    endDateMinDate,
    endDateSelectedDate,
    onEndDateChange,
    onClearEndDate,
    formatDate
  };
};

export default useGroupEndDate;
